import React, { useEffect, useState } from 'react';
import axiosInstance from '../axiosConfig'; 
import '../styles/loader.css';
import Loader from "../components/Loader";

const PricingList = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const fetchCategories = async () => {
            try {
                const response = await axiosInstance.get('/service-categories');
                if (response.data.success) {
                    setCategories(response.data.categories);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

    if (loading) {
       return <Loader />;
    }

    return (
        <section className="no-top no-bottom" aria-label="section">
            <div className="container">
                {categories.map((category, index) => (
                    <div key={index}>
                        <div className="row">
                            <div className={`col-lg-6 ${index % 2 === 0 ? 'offset-lg-2' : 'offset-lg-4'}`}>
                                <div className="d-sch-table">
                                    <h2 className="text-center wow fadeIn">{category.category}</h2>
                                    <div className="de-separator"></div>
                                    <div className="sc-wrap">
                                        <div className="def-list-dots">
                                            {category.services.map((service, i) => (
                                                <dl key={i}>
                                                    <dt>
                                                        <span>{service.name}</span>
                                                    </dt>
                                                    <dd>{service.price}</dd>
                                                </dl>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="d-deco"></div>
                                </div>
                            </div>
                        </div>
                        <div className="spacer-double"></div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default PricingList;
